import { StatusChip } from '@dealstack/frontend/shared/components/Chips/CommonChips';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { memo, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';
import type { ISubListItemProps } from './SubListItem.types';

const SubListItem = ({ className, state, status, title, onClick }: ISubListItemProps) => {
	const iconVariant: PredefinedIcons = useMemo(() => {
		switch (state) {
			case 'active':
				return 'radio-checked';
			case 'visited':
				return 'checkmark-circle-contained-filled';
			default:
				return 'radio-unchecked';
		}
	}, [state]);

	return (
		<div onClick={onClick} className={className}>
			<StateIcon size="md" variant={iconVariant} />
			<Text variant="button">{title}</Text>
			{!!status && (
				<StatusChipWrapper>
					<StatusChip iconSize="md" variant={status} />
				</StatusChipWrapper>
			)}
		</div>
	);
};

const StateIcon = styled(Icon)`
	margin-right: 0.563rem;
`;

const StatusChipWrapper = styled.div`
	margin-left: auto;
	padding-left: 1em;
	${StatusChip} {
		padding: 0.15em 0.37em;
	}
`;

const Memoized = memo(SubListItem);
const Styled = styled(Memoized)`
	display: flex;
	flex-direction: row;
	align-items: center;

	padding: 0.513rem 0.563rem;
	border-radius: 4px 0 0 4px;

	${Icon} {
		flex-shrink: 0;
	}

	${({ theme, onClick }) =>
		onClick
			? `
            cursor: pointer;
            &:hover {
                background-color: ${theme.v2.color.primary[600]};
            }
    `
			: ``}

	${({ theme, state }) => {
		switch (state) {
			case 'inactive':
				return css`
					${Text} {
						color: ${theme.v2.color.neutral[600]};
					}
				`;
			case 'visited':
				return css`
					${StateIcon}.svg, ${Text} {
						color: ${theme.v2.color.secondary[800]};
					}
				`;
			default:
				return css`
					${Text} {
						font-weight: 700;
					}
				`;
		}
	}}
`;

export { Styled as SubListItem };
